import React from "react";
import { CrudManager } from "../../components/admin/CrudManager";
import { SectionHeading } from "../../components/Loader";

const TRADES = ["Plumbing", "Electrical", "HVAC", "Roofing", "Flooring", "Painting", "Landscaping", "Appliances", "Windows", "General Construction"];

export default function Contractors() {
  return (
    <div className="space-y-6 arq-fade-up">
      <SectionHeading overline="Network" title="Contractors & Vendors" />
      <CrudManager
        title="Contractor"
        listUrl="/contractors"
        createUrl="/contractors"
        itemBase="/contractors"
        queryKey={["contractors"]}
        defaults={{ active: true }}
        columns={[
          { key: "company_name", label: "Company" },
          { key: "trade", label: "Trade" },
          { key: "primary_contact", label: "Contact" },
          { key: "phone", label: "Phone" },
          { key: "email", label: "Email" },
        ]}
        fields={[
          { key: "company_name", label: "Company Name", full: true },
          { key: "trade", label: "Trade", type: "select", options: TRADES },
          { key: "primary_contact", label: "Primary Contact" },
          { key: "email", label: "Email" },
          { key: "phone", label: "Phone" },
          { key: "service_area", label: "Service Area" },
          { key: "address", label: "Address", full: true },
          { key: "active", label: "Active", type: "checkbox" },
          { key: "notes", label: "Notes", type: "textarea", full: true },
        ]}
      />
    </div>
  );
}
